import { useState } from "react";
import newborn from "../assets/images/new-born-toy.avif";
import rctoys from "../assets/images/rc-toys.jpg";
import stemtoys from "../assets/images/stem-toys.jpg";
import artAndCraft from "../assets/images/art-craft.jpg";
import roleplay from "../assets/images/role-play.jpg";
import more from "../assets/images/more.jpg";

const categories = [
    {
        name: "Newborn Toys",
        desc: "Safe, colorful and engaging toys designed specially for newborns to learn and explore.",
        img: newborn,
    },
    {
        name: "RC Toys",
        desc: "High-performance remote control cars, helicopters, and more for endless fun.",
        img: rctoys,
    },
    {
        name: "STEM Toys",
        desc: "Educational toys that spark curiosity and build science, technology, engineering and math skills.",
        img: stemtoys,
    },
    {
        name: "Art and Craft",
        desc: "Boost creativity with DIY craft kits, coloring, painting, and more.",
        img: artAndCraft,
    },
    {
        name: "Roleplay Toys",
        desc: "Encourage imagination with roleplay sets like kitchens, doctor kits, and more.",
        img: roleplay,
    },
    {
        name: "Many More",
        desc: "Discover a wide range of toys designed for fun, creativity, and learning.",
        img: more,
    },
];

export default function Product() {
    const [active, setActive] = useState(categories[0]);

    return (
        <section id="product" className="categories-section">
            <h2 className="section-title">Our Bestselling Categories</h2>

            <div className="categories-container">
                {/* Sidebar */}
                <div className="categories-sidebar">
                    {categories.map((cat) => (
                        <button
                            key={cat.name}
                            onClick={() => setActive(cat)}
                            className={`category-btn ${
                                active.name === cat.name ? "active" : ""
                            }`}
                        >
                            {cat.name}
                        </button>
                    ))}
                </div>

                {/* Content */}
                <div className="categories-content">
                    <img src={active.img} alt={active.name} className="category-image" />
                    <h3>{active.name}</h3>
                    <p>{active.desc}</p>
                    <a href="#" className="explore-btn">
                        Explore {active.name}
                    </a>
                </div>
            </div>
        </section>
    );
}
